import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

// Home Page Components
import Hero from './components/HeroSections';
import HowItWorks from './components/HowItWorks'; // "Timeline"
import BrowseSpecialty from './components/BrowseSpecialty'; // New
import FeaturedProviders from './components/FeaturedProviders';
import Testimonials from './components/Testimonials';
import FinalCTA from './components/FinalCTA'; // New
import AIServicesSection from './components/AIServicesSection'; // New


export default function HomePage() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-grow">
        {/* 1. Hero & Search */}
        <Hero />

        <AIServicesSection />

        {/* 3. Featured Providers (API) */}
        <FeaturedProviders />

        {/* 6. Testimonials */}
        <Testimonials />
          
        {/* 4. Browse By Specialty */}
        <BrowseSpecialty />
        
        {/* 5. How It Works (Timeline) */}
        <HowItWorks />
        

        
        {/* 7. Final CTA */}
        <FinalCTA />
      </main>

      <Footer />
    </div>
  );
}